import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";
import useTabs from "src/hooks/useTabs";

import ThemeContext from "../../context";
import Context from "../context";
import useGetFundsFiltered from "./hooks/useGetFundsFiltered";

// ----------------------------------------------------------------------

export const useFundsSelectionLogic = () => {
	const { actions: themeActions } = useContext(ThemeContext);
	const { actions } = useContext(Context);
	const { currentTab, onChangeTab } = useTabs("available");
	const { fundsAvailable, fundNotAvailable } = useGetFundsFiltered();

	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");

	const onPressBack = () => {
		themeActions.setStep(1);
		actions.onChangeSelectedPositions([]);
	};

	return {
		onPressBack,
		isMobile,
		currentTab,
		onChangeTab,
		fundsAvailable,
		fundNotAvailable,
		isDownMd
	};
};

export default useFundsSelectionLogic;
